import cssUtil from 'gw-portals-util-js/CssUtil';

import template from 'text!./Location.html';
import styles from './Location-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        scope: { location: '&' },
        template: cssUtil.hashTemplate(template, styles)
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/LocationReadonlyView/Location.js
// module id = 799
// module chunks = 0